import { isValid, parseISO } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import * as Parser from './Grammar.js';
export function parseDate(source) {
    const timeDelimRe = /[T ]/;
    const timeZoneRe = /[+-]\d\d(?::?\d\d)?$/;
    let date = parseISO(source);
    if (isValid(date)) {
        // Fast path, includes "Z" UTC designator
        if (source.includes('Z')) {
            return date.getTime();
        }
        /**
         * If there's a time part check for a time zone
         * suffix of the form: ("0" here can be any digit)
         * +00:00
         * +0000
         * +00
         * -00:00
         * -0000
         * -00
         */
        if (timeDelimRe.test(source)) {
            const [, timePart] = source.split(timeDelimRe);
            // Has an explicit timezone, return as-is
            if (timeZoneRe.test(timePart)) {
                return date.getTime();
            }
        }
        // No time zone designator, re-parse as local -> UTC
        date = zonedTimeToUtc(source, 'Z');
        if (isValid(date)) {
            return date.getTime();
        }
    }
    return NaN;
}
export class Tree {
    static Parse(source) {
        return new Tree(source, Parser.parse(source, {
            parseDate,
        }));
    }
    constructor(source, nodes) {
        this._source = source;
        this._nodes = nodes;
    }
    get source() {
        return this._source;
    }
    get nodes() {
        return this._nodes;
    }
    get root() {
        return this.nodes[0];
    }
}
export var NodeType;
(function (NodeType) {
    // Identifiers
    NodeType["Identifier"] = "Identifier";
    // Literals
    NodeType["NullLiteral"] = "NullLiteral";
    NodeType["BooleanLiteral"] = "BooleanLiteral";
    NodeType["NumberLiteral"] = "NumberLiteral";
    NodeType["HexLiteral"] = "HexLiteral";
    NodeType["StringLiteral"] = "StringLiteral";
    NodeType["RegExpLiteral"] = "RegExpLiteral";
    NodeType["FieldLiteral"] = "FieldLiteral";
    NodeType["DateLiteral"] = "DateLiteral";
    /**
     * Expressions
     */
    NodeType["UnaryExpression"] = "UnaryExpression";
    NodeType["BinaryExpression"] = "BinaryExpression";
    NodeType["LogicalExpression"] = "LogicalExpression";
    NodeType["CaseExpression"] = "CaseExpression";
    NodeType["CaseWhen"] = "CaseWhen";
    NodeType["CaseElse"] = "CaseElse";
    NodeType["CallExpression"] = "CallExpression";
})(NodeType || (NodeType = {}));
